import { computed, type ComputedRef } from 'vue'
import { useOverviewStore } from '../../stores/overview'

interface UseButtonScrollup {
  disabled: ComputedRef<boolean>
  doScrollUp: Function
}

//------------------------------------------------
export function useButtonScrollup(): UseButtonScrollup {
  const overviewStore = useOverviewStore()

  const disabled = computed(() => !overviewStore.hasScrollup)

  function doScrollUp() {
    overviewStore.slideUp()
  }

  return {
    disabled,
    doScrollUp,
  }
}

//------------------------------------------------
export function useButtonScrollupMock(): UseButtonScrollup {
  const disabled = computed(() => false)

  function doScrollUp() {
    console.debug('doScrollUp()')
  }

  return {
    disabled,
    doScrollUp,
  }
}
